const state = {
  shellConst: {}
};

const mutations = {
  SET_SHELLCONST: (state, shellConst) => {
    state.shellConst = shellConst;
  }
};

const actions = {
  setShellConst({ commit }, shellConst) {
    if (shellConst && shellConst.websiteName) {
      const isZzTax = localStorage.getItem("isZzTax");
      document.title = shellConst.websiteName + "-" + (isZzTax * 1 ? "中转服务商端" : "服务商端");
    }
    commit("SET_SHELLCONST", shellConst);
  },
  setSystemTitle(_, isZzTax) {
    document.title = (this.state.domain.shellConst?.websiteName + "-" || "") + (isZzTax * 1 ? "中转服务商端" : "服务商端");
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
